// extracted by mini-css-extract-plugin
export var displayNone = "_oz-6";
export var imgContainer = "_oz-2";
export var overflowHidden = "_oz-3";
export var productInfoCardButtonContainer = "_oz-5";
export var productTitleText = "_oz-4";
export var rightArrow = "_oz-1";
export var rightArrowContainer = "_oz-0";